import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const ThankYouParent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Thank You - Sparklyt';
  }, []);

  return (
    <div className="thank-you-page">
      <div className="container">
        <div className="thank-you-content">
          <h1 className="hero-medium">You're officially on the waitlist.</h1>
          <div className="content-spacing">
            <p className="body-large">
              We are inviting a limited group of parents to be part of Sparklyt's first phase. Early access includes the initial toolkit release, direct feedback channels, and priority updates as we expand.
            </p>
            <p className="body-large">
              If you would like to share your perspective or explore this more deeply, you are welcome to connect directly with the founders:
            </p>
            <div className="founder-links" style={{ marginTop: '24px' }}>
              <p className="body-large">
                <a 
                  href="https://www.linkedin.com/in/m-pranav-7a0017275/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="linkedin-link"
                >
                  Pranav
                </a>
                {' '}– Founder
              </p>
              <p className="body-large">
                <a 
                  href="https://www.linkedin.com/in/theanuroopnair/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="linkedin-link"
                >
                  Anuroop
                </a>
                {' '}– Co-Founder
              </p>
            </div>
          </div>
          <div className="thank-you-back-button">
            <Button 
              className="btn-secondary" 
              onClick={() => navigate('/')}
            >
              <ArrowLeft size={16} className="mr-2" />
              Back to home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouParent;
